import FormGroup from '../FormGroup/FormGroup';
import {
  AddressLineOneErrorMessages,
  getAddressLineOneCharacterCountLabel,
  getAddressLineOneError,
} from '../../../utils/validations';

type AddressLineOneFieldProps = {
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessages?: AddressLineOneErrorMessages;
  id?: string;
  name?: string;
  required?: boolean;
  autoFocus?: boolean;
  className?: string;
  fontSize?: string;
  labelFontSize?: string;
};

export default function AddressLineOneField({
  label,
  placeholder,
  value,
  onChange,
  errorMessages,
  id = 'addressLineOne',
  name = 'addressLineOne',
  required = false,
  autoFocus = false,
  className = '',
  fontSize,
  labelFontSize,
}: AddressLineOneFieldProps) {
  return (
    <FormGroup
      id={id}
      name={name}
      label={label}
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rightLabel={getAddressLineOneCharacterCountLabel(value)}
      errorText={getAddressLineOneError(value, errorMessages)}
      required={required}
      autoFocus={autoFocus}
      className={className}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
    />
  );
}
